import AchievementsPage from '@/pages/Achievements/achievements';
import ManageQuiz from '@/pages/Contents/BUZZ/Quiz/ManageQuiz';
import ClassForm from '@/pages/Contents/LMS/Classes/ClassForm';
import ProgramWorkshopForm from '@/pages/Contents/LMS/Classes/ProgramWorkshopForm';
import CourseClasses from '@/pages/Contents/LMS/Courses/ManageCourse/CourseClasses';
import ManageProgram from '@/pages/Contents/LMS/Programs/ManageProgram';
import ProgramClasses from '@/pages/Contents/LMS/Programs/ManageProgram/ProgramClass';
import Data from '@/pages/Data';
import EnrolledCourse from '@/pages/EnrolledCourse';
import Integration from '@/pages/Integration/integration';
import CreateCoursePage from '@/pages/Mine/MyCreations/CreateCourse';
import EditCoursePage from '@/pages/Mine/MyCreations/EditCourse';
import SuggestedContentPage from '@/pages/Mine/MyCreations/SuggestedContent';
import OnboardingAcknowledgement from '@/pages/Onboarding/Acknowledgment';
import OnboardingDescription from '@/pages/Onboarding/Description';
import OnboardingIntroduction from '@/pages/Onboarding/Introduction';
import SelectionInterests from '@/pages/Onboarding/SelectionInterests';
import FormGroup from '@/pages/People/FormGroup/FormGroup';
import ProfilePage from '@/pages/Profile';
import PublicProfilePage from '@/pages/PublicProfile';
import Recommendation from '@/pages/Recommendation';
import Saml from '@/pages/Saml/saml';
import QuestionnaireScreen from '@/pages/Student/LMS/Evaluation/QuestionnaireScreen';
import ProgramPage from '@/pages/Student/Program/program';
import TrainingsPage from '@/pages/Trainings';
import React from 'react';
import { HashRouter, Switch } from 'react-router-dom';
import { CategoryManagement } from '../pages/Config/CategoryManagement';
import Customization from '../pages/Config/Customization/customization';
import Config from '../pages/Config/config';
import ContentPage from '../pages/Content/content';
import ManageCourse from '../pages/Contents/LMS/Courses/ManageCourse';
import CreateItem from '../pages/Contents/Playlist/Items/CreateItem';
import EditItem from '../pages/Contents/Playlist/Items/EditItem';
import AddItemToList from '../pages/Contents/Playlist/Lists/AddItemToList';
import CreateList from '../pages/Contents/Playlist/Lists/CreateList';
import EditList from '../pages/Contents/Playlist/Lists/EditList';
import Contents from '../pages/Contents/contents';
import Login from '../pages/Login/login';
import Logout from '../pages/Logout/logout';
import Master from '../pages/Master/master';
import MinePage from '../pages/Mine/mine';
import PageNotFound from '../pages/PageNotFound/PageNotFound';
import FormPerson from '../pages/People/FormPerson';
import People from '../pages/People/people';
import SearchResultPage from '../pages/SearchResult';
import SectionPage from '../pages/Sections/section';
import CategoryPage from '../pages/Student/Category/category';
import LMSCoursePage from '../pages/Student/LMS/Course/course';
import EvaluationPage from '../pages/Student/LMS/Evaluation';
import LessonPageLms from '../pages/Student/LMS/Lesson/lesson';
import LessonPage from '../pages/Student/Lesson/lesson';
import CoursePage from '../pages/Student/Playlist/Course/course';
import Route from './Route';

const Routes: React.FC = () => (
    <HashRouter>
        <Switch>
            <Route component={Login} exact path="/login" />
            <Route component={Saml} exact path="/saml" />
            <Route component={Integration} exact path="/integration" />
            <Route component={Logout} exact isPrivate path="/logout" />
            <Route component={OnboardingIntroduction} exact path="/onboardingIntroduction" />
            <Route component={OnboardingDescription} exact path="/onboardingDescription" />
            <Route component={OnboardingAcknowledgement} exact path="/onboardingAcknowledgement" />
            <Route component={SelectionInterests} exact path="/onboardingSelectionInterests" />

            <Route component={Master} exact isPrivate path="/" />

            <Route component={Data} isAdmin isPrivate path="/data" />

            <Route component={FormPerson} isAdmin isPrivate path="/people/create" />
            <Route component={FormPerson} isAdmin isPrivate path="/people/:id/edit" />
            <Route component={People} isAdmin isPrivate path="/people" />

            <Route component={FormGroup} isAdmin isPrivate path="/group/create" />
            <Route component={FormGroup} isAdmin isPrivate path="/group/:id/edit" />

            <Route component={PublicProfilePage} exact isPrivate path="/profile/:id/info" />
            <Route component={ProfilePage} isPrivate path="/profile" />

            {/* LMS Routes */}
            <Route component={ClassForm} isAdmin isPrivate path="/contents/lms/courses/:id/classes/:classId" />
            <Route component={CourseClasses} isAdmin isPrivate path="/contents/lms/courses/:id/classes" strict />
            <Route component={ManageCourse} isAdmin isPrivate path="/contents/lms/courses/:id" />
            <Route component={ManageCourse} isAdmin isPrivate path="/contents/lms/courses/" strict />
            <Route component={ProgramWorkshopForm} isAdmin isPrivate path="/contents/lms/programs/:id/classes/:classId/courses/:courseId" />
            <Route component={ClassForm} isAdmin isPrivate path="/contents/lms/programs/:id/classes/:classId" />
            <Route component={ProgramClasses} isAdmin isPrivate path="/contents/lms/programs/:id/classes" strict />
            <Route component={ManageProgram} isAdmin isPrivate path="/contents/lms/programs/:id" strict />
            <Route component={ManageProgram} isAdmin isPrivate path="/contents/lms/programs/" strict />
            <Route component={ManageQuiz} isAdmin isPrivate path="/contents/buzz/tests/:id/questions/" />
            <Route component={ManageQuiz} isAdmin isPrivate path="/contents/buzz/tests/:id/results/" />
            <Route component={ManageQuiz} isAdmin isPrivate path="/contents/buzz/tests/:id" />
            <Route component={ManageQuiz} isAdmin isPrivate path="/contents/buzz/tests/" strict />
            <Route
                component={QuestionnaireScreen}
                exact
                isPrivate
                path="/lms/enrollments/:enrollmentId/courses/:courseId/lessons/:lessonId/evaluations/:evaluationId/class/:classEnrollmentId/questionnaire"
            />
            <Route component={LessonPageLms} exact isPrivate path="/lms/enrollments/:enrollmentId/courses/:courseId/lessons/:lessonId" />
            <Route component={EvaluationPage} exact isPrivate path="/lms/enrollments/:enrollmentId/courses/:courseId/evaluations/:lessonId" />

            <Route component={ContentPage} exact isPrivate path="/contents/:id" />
            <Route component={Contents} isAdmin isPrivate path="/contents" />
            <Route component={Recommendation} exact isPrivate path="/recommendations/contents/:contentId" />

            <Route component={CreateItem} isAdmin isPrivate path="/items/create" />
            <Route component={EditItem} isAdmin isPrivate path="/items/:id/edit" />
            <Route component={CreateList} isAdmin isPrivate path="/lists/create" />
            <Route component={EditList} exact isAdmin isPrivate path="/lists/:id/edit" />
            <Route component={AddItemToList} exact isAdmin isPrivate path="/lists/:id" />
            <Route component={CategoryPage} isPrivate path="/category/:id" />
            <Route component={SectionPage} isPrivate path="/sections/:viewTypeResource" />
            <Route component={SuggestedContentPage} exact isPrivate path="/mine/courses/:courseId/suggestedcontents" />
            <Route component={ContentPage} exact isPrivate path="/mine/courses/:courseId/contents/:id" />
            <Route component={CreateCoursePage} isPrivate path="/mine/courses/create" />
            <Route component={EditCoursePage} isPrivate path="/mine/courses/:courseId/edit" />
            <Route component={MinePage} isPrivate path="/mine" />
            <Route component={Config} exact isAdmin isPrivate path="/config" />
            <Route component={Customization} isAdmin isPrivate path="/config/customization" />
            <Route component={CategoryManagement} isAdmin isPrivate path="/config/categories" />
            <Route component={LMSCoursePage} exact isPrivate path="/lms/enrollments/:enrollmentId/courses/:courseId" />
            <Route component={CoursePage} exact isPrivate path="/courses/:id" />
            <Route component={LessonPage} exact isPrivate path="/courses/:courseId/lessons/:lessonId" />
            <Route component={SearchResultPage} isPrivate path="/search-result" />
            <Route component={ProgramPage} exact isPrivate path="/lms/enrollments/:enrollmentId/programs/:id" />
            <Route component={AchievementsPage} isPrivate path="/achievements" />
            <Route component={TrainingsPage} isPrivate path="/trainings" />
            <Route component={EnrolledCourse} isPrivate path="/lms/class/:classId" />
            <Route component={PageNotFound} exact isPrivate path="/page-not-found" />
            <Route component={PageNotFound} />
        </Switch>
    </HashRouter>
);

export default Routes;
